import { Box, Divider, Stack, Typography } from '@mui/material'
import React from 'react'
import { alcohol_user_foot, bloodSugarLevels, currentMedications, dietOpt, oralMedications, riskFactorExerciseOpt, smoker_user_foot, smokerOpt } from '../../DiabeticForm/sub-form-sections/formOptions'
import EngineeringRoundedIcon from '@mui/icons-material/EngineeringRounded';
import { InputLabelStyled, ParentSelectBox } from '../../DiabeticForm/sub-form-sections/PresentingComplaintSection';
import InputController, { InputControllerWithIcon } from '../../../../components/InputController/InputController';
import RadioButtonController from '../../../../components/RadioButtonController/RadioButtonController';
import CheckboxController from '../../../../components/CheckboxSelector/CheckboxSelector';
import { currentMedicationsFoot, typeOfDiagnosisFoot } from './formFootOptions';
import { CustomInputLable, InputContainer, ParentContainerSection } from '../FootForm';

const KnownPatientsFoot = (props) => {
    const {control, errors,  watch} = props

    const current_medication_value_foot= watch("known_patients_foot.current_medication");
  return (
   <>
 <ParentContainerSection heading="Section C - Known patients with DM">
        <InputContainer>
          <CustomInputLable>Known patients with DM</CustomInputLable>
          <InputController
            name="known_patients_foot.duration"
            control={control}
            errors={errors}
            size="small"
            fullWidth={false}
            placeholder="Treatment Years"
            isDisabled={true}
            isNumberField
            isSmall
          />
        </InputContainer>
        <InputContainer >
          <CustomInputLable>Type</CustomInputLable>
          <CheckboxController
            name={"known_patients_foot.type"}
            isRow={true}
            isMultiCheckbox={true}
            control={control}
            errors={errors}
            options={typeOfDiagnosisFoot}
            isDisabled={true}
            isHorizantalPadding={true}
            isCustomPadding
            size="small" />
        </InputContainer>
        <InputContainer>

          <CustomInputLable required>Currently on Medication</CustomInputLable>
          <RadioButtonController
            name="known_patients_foot.current_medication"
            control={control}
            errors={errors}
            options={currentMedicationsFoot}
            isDisabled
            isRow
          />
        </InputContainer>

        {current_medication_value_foot === "1" && <InputContainer>
          <CustomInputLable>Medication Type</CustomInputLable>
          <CheckboxController
            name={"known_patients_foot.known_patients_foot_medication_oral_injection"}
            isRow={true}
            isMultiCheckbox={true}
            control={control}
            errors={errors}
            options={oralMedications}
            isHorizantalPadding={true}
            isCustomPadding
            isDisabled
            size="small"
          />
        </InputContainer>}

        <CustomInputLable >Blood Sugar Level</CustomInputLable>
        <InputContainer style={{  marginTop:"1rem" }}>
          <CustomInputLable  >RBS</CustomInputLable>
          <InputController
            name="known_patients_foot.blood_sugar_level.RBS"
            control={control}
            errors={errors}
            size="small"
            fullWidth={false}
            placeholder="RBS"
            isSmall
            isDisabled
          />
        </InputContainer>
        <InputContainer>
          <CustomInputLable >FBS</CustomInputLable>
          <InputController
            name="known_patients_foot.blood_sugar_level.FBS"
            control={control}
            errors={errors}
            size="small"
            fullWidth={false}
            placeholder="FBS"
            isSmall
            isDisabled
          />
        </InputContainer>
        <InputContainer>
          <CustomInputLable >HbA1c</CustomInputLable>
          <InputController
            name="known_patients_foot.blood_sugar_level.HbA1c"
            control={control}
            errors={errors}
            size="small"
            fullWidth={false}
            placeholder="HbA1c"
            isSmall
            isDisabled
          />
        </InputContainer>

        <InputContainer >

          <CustomInputLable required>Blood Sugar Levels</CustomInputLable>
          <RadioButtonController
            name="known_patients_foot.blood_sugar_levelsfoot"
            control={control}
            errors={errors}
            options={bloodSugarLevels}
            isRow
            isDisabled
          />
        </InputContainer>

        <InputContainer >

          <CustomInputLable required>Risk Factors Exercise</CustomInputLable>
          <RadioButtonController
            name="known_patients_foot.risk_factor_excercise_foot"
            control={control}
            errors={errors}
            options={riskFactorExerciseOpt}
            isRow
            isDisabled
          />
        </InputContainer>

        <InputContainer>
          <CustomInputLable >Alcohol Use</CustomInputLable>
          <RadioButtonController
            name="known_patients_foot.alochol_use_foot"
            control={control}
            errors={errors}
            options={alcohol_user_foot}
            isRow
            isDisabled
          />
        </InputContainer>

        <InputContainer>

          <CustomInputLable required>Diet</CustomInputLable>
          <RadioButtonController
            name="known_patients_foot.diet_foot"
            control={control}
            errors={errors}
            options={dietOpt}
            isRow
            isDisabled
          />
        </InputContainer>
        <InputContainer>
          <CustomInputLable >Smoker</CustomInputLable>
            <RadioButtonController
            name="known_patients_foot.smoker_foot"
            control={control}
            errors={errors}
            options={smoker_user_foot}
            isRow
            isDisabled
          />
        </InputContainer>

      </ParentContainerSection>



{/*  */}
{/* 
   <ParentContainerSection heading="Section C: Known Patients with DM">
            <Box sx={{ display: "flex", gap: "1rem", alignItems: "center", }}>
                <InputLabelStyled sx={{ whiteSpace: "normal", flexBasis: "180px"}}>Duration of illness (years)</InputLabelStyled>
                         <ParentSelectBox>
                         <Box sx={{display:"flex", flexDirection: "column", gap:"1rem", width: "100%"}}>
                         <Stack  sx={{ display:"flex", flexDirection:"row", gap:"1rem", alignItems: "center", flex: "1 1 0" }}>
                        
                         <InputControllerWithIcon
                                    name="known_patients_foot.duration"
                                    label="Duration"
                                    control={control}
                                    errors={errors}
                                    isSmall={true}
                                    size="small"
                                    isDisabled={true}
                                    icon={<EngineeringRoundedIcon/>}
                            />  
    
<InputLabelStyled sx={{ whiteSpace: "normal", flexBasis:"fit-content"}}>Type</InputLabelStyled>
                            <CheckboxController
                               name="known_patients_foot.type"
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                options={typeOfDiagnosisFoot}
                                isHorizantalPadding={false}
                                isDisabled
                                isMarginLeft={true}
                            />
                         </Stack>
                         </Box>
                </ParentSelectBox>
                </Box>


               
                <Box sx={{ display: "flex", gap: "1rem", alignItems: "center", }}>
                    <InputLabelStyled sx={{ whiteSpace: "normal", }}>Current on Medications?</InputLabelStyled>
                         <ParentSelectBox>
                         <Box sx={{display:"flex", flexDirection: "column", gap:"1rem", width: "100%"}}>
                         <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                            <RadioButtonController
                                    name="known_patients_foot.current_medication"
                                    control={control}
                                    errors={errors}
                                    options={dietOpt}
                                    isRow={true}
                                    isDisabled
                            />
                         </Stack>
                         </Box>
                </ParentSelectBox>
                </Box>

                <Box sx={{ display: "flex", gap: "1rem", alignItems: "center", }}>
                    <InputLabelStyled sx={{ whiteSpace: "normal", }}>Blood Sugar Level</InputLabelStyled>
                         <ParentSelectBox>
                         <Box sx={{display:"flex", flexDirection: "column", gap:"1rem", width: "100%"}}>
                         <Stack direction="row" spacing={2} alignItems="center" sx={{gap:"2rem"}}>
                         <InputControllerWithIcon
                                    name="known_patients_foot.blood_sugar_level.RBS"
                                    label="RBS"
                                    control={control}
                                    errors={errors}
                                    isSmall={true}
                                    size="small"
                                    isDisabled={true}
                                    icon={<EngineeringRoundedIcon/>}
                            /> 
                         <InputControllerWithIcon
                                    name="known_patients_foot.blood_sugar_level.FBS"
                                    label="FBS"
                                    control={control}
                                    errors={errors}
                                    isSmall={true}
                                    size="small"
                                    isDisabled={true}
                                    icon={<EngineeringRoundedIcon/>}
                            /> 
                         <InputControllerWithIcon
                                    name="known_patients_foot.blood_sugar_level.HbA1c"
                                    label="HbA1c"
                                    control={control}
                                    errors={errors}
                                    isSmall={true}
                                    size="small"
                                    isDisabled={true}
                                    icon={<EngineeringRoundedIcon/>}
                            /> 
                         </Stack>
                         </Box>
                </ParentSelectBox>
                </Box>



            <Box sx={{ display: "flex", gap: "1rem", alignItems: "center", }}>
                    <InputLabelStyled sx={{ whiteSpace: "normal",}}>Blood Sugar Levels</InputLabelStyled>
                         <ParentSelectBox>
                         <Box sx={{display:"flex", flexDirection: "column", gap:"1rem", width: "100%"}}>
                         <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                         <RadioButtonController
                                name="known_patients_foot.blood_sugar_levelsfoot"
                                isRow={true}
                                control={control}
                                errors={errors}
                                options={bloodSugarLevels}
                                isDisabled
                            />
                         </Stack>
                         </Box>
                </ParentSelectBox>
                </Box>

                <Box sx={{ display: "flex", gap: "1rem", alignItems: "center", }}>
                    <InputLabelStyled sx={{ whiteSpace: "normal", }}>Risk Factor Exercise</InputLabelStyled>
                         <ParentSelectBox>
                         <Box sx={{display:"flex", flexDirection: "column", gap:"1rem", width: "100%"}}>
                         <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                             <RadioButtonController
                              name="known_patients_foot.risk_factor_excercise_foot"
                                isRow={true}
                                control={control}
                                errors={errors}
                                options={riskFactorExerciseOpt}
                                isDisabled
                            />
                         </Stack>
                         </Box>
                </ParentSelectBox>
                </Box>


                <Box sx={{ display: "flex", gap: "1rem", alignItems: "center", }}>
                    <InputLabelStyled sx={{ whiteSpace: "normal", }}>Diet</InputLabelStyled>
                         <ParentSelectBox>
                         <Box sx={{display:"flex", flexDirection: "column", gap:"1rem", width: "100%"}}>
                         <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                         <RadioButtonController
                                    name="known_patients_foot.diet_foot"
                                    control={control}
                                    errors={errors}
                                    options={dietOpt}
                                    isRow={true}
                                    isDisabled
                            />
                         </Stack>
                         </Box>
                </ParentSelectBox>
                </Box>

                <Box sx={{ display: "flex", gap: "1rem", alignItems: "center", }}>
                <InputLabelStyled sx={{ whiteSpace: "normal", }}>Alochol use (units per week)</InputLabelStyled>
                         <ParentSelectBox>
                         <Box sx={{display:"flex", flexDirection: "column", gap:"1rem", width: "100%"}}>
                         <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                        
                         <InputControllerWithIcon
                                    name="known_patients_foot.alochol_use_foot"
                                    label="Alochol Use"
                                    control={control}
                                    errors={errors}
                                    isSmall={true}
                                    size="small"
                                    isDisabled={true}
                                    icon={<EngineeringRoundedIcon/>}
                            />  
                         </Stack>
                         </Box>
                </ParentSelectBox>
                </Box>

                <Box sx={{ display: "flex", gap: "1rem", alignItems: "center", }}>
                <InputLabelStyled sx={{ whiteSpace: "normal", }}>Smoke</InputLabelStyled>
                         <ParentSelectBox>
                         <Box sx={{display:"flex", flexDirection: "column", gap:"1rem", width: "100%"}}>
                         <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
                             <CheckboxController
                               name="known_patients_foot.smoker_foot"
                                isRow={true}
                                isMultiCheckbox={true}
                                control={control}
                                errors={errors}
                                options={smokerOpt}
                                isHorizantalPadding={false}
                                isDisabled
                                isMarginLeft={true}
                            />
                         </Stack>
                         </Box>
                </ParentSelectBox>
                </Box>

                <Divider/>

                </ParentContainerSection> */}
   </>
  )
}

export default KnownPatientsFoot